/**
 * Defaults para Tablas y Paginación
 */

export const dataDefaults: Record<string, Record<string, unknown> | undefined> = {
  VDataTable: {
    density: 'comfortable',
    itemsPerPageOptions: [10, 25, 50, 100],
    VBtn: {
      variant: 'text',
      size: 'small',
    },
  },

  VDataTableServer: {
    density: 'comfortable',
    itemsPerPageOptions: [10, 25, 50, 100],
  },

  VPagination: {
    density: 'comfortable',
    rounded: 'lg',
    activeColor: 'primary',
  },
}
